import { reviewSeat, sameSeat, type SeatCandidate } from "@anjabom/core";
import { useState } from "react";
import { seatKey } from "../lib/contribution-client";
import { useLocalState } from "../state/LocalStateProvider";
import { BottomSheet } from "./BottomSheet";
import { SeatFactsCard } from "./SeatFactsCard";
import { SeatMemoryList } from "./SeatMemoryList";
import { SeatPublicTips } from "./SeatPublicTips";

export function SeatPreviewSheet({ candidate, onClose, onConfirm, message, variant = "overview" }: {
	candidate: SeatCandidate;
	onClose(): void;
	onConfirm(): void;
	message?: string;
	variant?: "overview" | "tabs";
}) {
	const { state } = useLocalState();
	const [tab, setTab] = useState<"location" | "people">("location");
	const key = seatKey(candidate);
	const memories = state.reviews.filter((review) => {
		const seat = reviewSeat(review, state);
		return seat && sameSeat(seat, candidate);
	});

	const people = <SeatPublicTips key={key} candidate={candidate} limit={2} />;
	const location = <><SeatFactsCard candidate={candidate} compact /><section className="seat-preview-boundary"><span className="seat-preview-marker" aria-hidden="true">?</span><div><h3>이번 공연의 무대는 확인 전이에요</h3><p>돌출무대·가림·실제 시야는 공연별 예매 안내와 관람 기록을 따로 확인해요.</p></div></section></>;

	return <BottomSheet title={`${candidate.sectionCode} ${candidate.rowLabel}열 ${candidate.seatNumber}번`} onClose={onClose}>
		<div className="seat-preview" data-preview-variant={variant}>
			<p className="seat-preview-venue">{candidate.venueName} · {candidate.spaceName}</p>
			{variant === "tabs" ? <div className="seat-preview-tabs" role="tablist" aria-label="확인할 정보">{(["location", "people"] as const).map((id) => <button type="button" role="tab" key={id} id={`preview-tab-${id}`} aria-selected={tab === id} aria-controls="preview-panel" tabIndex={tab === id ? 0 : -1} onKeyDown={(event) => { if (["ArrowLeft", "ArrowRight"].includes(event.key)) { event.preventDefault(); const next = tab === "location" ? "people" : "location"; setTab(next); document.getElementById(`preview-tab-${next}`)?.focus(); } }} onClick={() => setTab(id)}>{id === "location" ? "공식 위치" : "사람 기록"}</button>)}</div> : null}
			{variant === "tabs" ? <div id="preview-panel" role="tabpanel" aria-labelledby={`preview-tab-${tab}`}>{tab === "location" ? location : people}</div> : <>{location}{people}</>}
			{memories.length ? <details className="seat-preview-memory"><summary>이 자리에 남긴 내 기억 {memories.length}개</summary><p className="micro">이 기기의 개인 기록이에요. 공개 한 줄과 별도로 보관해요.</p><SeatMemoryList reviews={memories} state={state} /></details> : null}
			<div className="seat-preview-actions">{message ? <p role="alert">{message}</p> : null}<button className="button button-primary" type="button" onClick={onConfirm}>이 자리 담고 자세히 보기</button><p className="micro">후보에 저장해 두고 다른 자리와 비교할 수 있어요.</p></div>
		</div>
	</BottomSheet>;
}
